import { createRouter as createTanStackRouter } from '@tanstack/react-router'
import { routeTree } from './routeTree.gen'

// Browser RUM. Dynamic + document-guarded so the browser-only OTel web SDK
// never enters the SSR module graph (it would evaluate `window`/`document`
// during server render). No-ops unless VITE_OTEL_RUM_ENABLED === 'true'.
if (typeof document !== 'undefined') {
  // Best-effort: a chunk-load / CSP failure here must not surface as an
  // unhandled rejection — RUM is optional, so swallow init errors.
  void import('~/lib/otel-browser')
    .then((m) => m.initBrowserTelemetry())
    .catch(() => {}) // NOSONAR — deliberate fire-and-forget; top-level await would block the router on optional RUM init (S7785)
}

export function getRouter() {
  return createTanStackRouter({
    routeTree,
    scrollRestoration: true,
    defaultPreload: 'intent',
  })
}

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof getRouter>
  }
}
